import script from "./DatabaseTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatabaseTable.vue?vue&type=script&setup=true&lang=ts"

import "./DatabaseTable.vue?vue&type=style&index=0&id=66255fd8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66255fd8"]])

export default __exports__